export interface TeamInviteSearchT {
    role?: string;
    organisation_id?: string;
    organisation_name?: string;
}

export function validateTeamInviteSearch(search: Record<string, unknown>): TeamInviteSearchT {
    const role = typeof search.role === "string" && search.role.trim() !== "" ? search.role : undefined;
    const organisation_id =
        typeof search.organisation_id === "string" && search.organisation_id.trim() !== ""
            ? search.organisation_id
            : undefined;
    const organisation_name =
        typeof search.organisation_name === "string" && search.organisation_name.trim() !== ""
            ? search.organisation_name
            : undefined;

    return { role, organisation_id, organisation_name };
}

export function hasTeamInviteContext(
    search: TeamInviteSearchT
): search is Required<Pick<TeamInviteSearchT, "role" | "organisation_id">> & TeamInviteSearchT {
    return Boolean(search.role && search.organisation_id);
}

export function toTeamInviteSearch(role: string, organisation: { organisation_id: string; organisation_name: string }) {
    return {
        role: role.toUpperCase(),
        organisation_id: organisation.organisation_id,
        organisation_name: organisation.organisation_name,
    };
}
